import { AccountTree } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

const ACAO_LABEL = {
  SB: "2ª via de fatura",
  VE: "Faturas vencidas",
  AV: "Faturas a vencer",
  LC: "Desbloqueio de confiança",
  ST: "Status da conexão"
};

const ehIa = data => ["ISP_IA", "HOSPEDAGEM_IA"].includes(String(data?.provider || "").toUpperCase());
const ehHospedagemIa = data => String(data?.provider || "").toUpperCase() === "HOSPEDAGEM_IA";

/**
 * Nó "Integração ERP (SGP/IXC)": ao chegar aqui o fluxo pede o CPF e entrega o
 * atendimento ao chatbot do ERP (2ª via, desbloqueio, status...). Nó terminal.
 */
export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();
  const title = ehHospedagemIa(data)
    ? "Agente Hospedagem"
    : ehIa(data)
    ? "Agente IA"
    : `ERP ${data.provider ? `(${String(data.provider).toUpperCase()})` : ""}`;

  return (
    <NodeCard color="#1B7A5E" icon={<AccountTree />} title={title} id={id} width={220}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={classes.slot}>
        <div className={classes.ellipsis} style={{ fontWeight: 600 }}>
          {data.integrationName || "Selecione a integração"}
        </div>
        <div style={{ fontSize: 11, fontWeight: 400, marginTop: 2 }}>
          {ehHospedagemIa(data)
            ? "IA de hospedagem + transferência p/ fila"
            : ehIa(data)
            ? "IA com ERP + transferência p/ fila"
            : ACAO_LABEL[data.acao] || "Ação da integração (config)"}
        </div>
      </div>
      <div className={classes.hint}>
        {ehHospedagemIa(data)
          ? "Busca imóveis, cota, pré-reserva e transfere se precisar"
          : ehIa(data)
          ? "Diagnostica, resolve e transfere se precisar"
          : "Pede o CPF e executa pelo chatbot do ERP"}
      </div>
    </NodeCard>
  );
});
